(($, Drupal) => {
  Drupal.behaviors.kafHeroSearch = {
    attach: (context) => {
      const $field = $('.hero__search .search__input-group input', context);

      if (!once('kafherosearch', '.hero__search .search__input-group input', context).length) {
        return;
      }

      const indexFragment = '#recipe_index';

      const executeHeroSearch = () => {
        if (window.dataLayer) {
          dataLayer.push({'event': 'submit_hero_search'});
        }
        const fieldVal = encodeURIComponent($field.val().toLowerCase());
        const searchPath = `/search?query=${fieldVal}${indexFragment}`;
        window.location.href = searchPath;
      }

      $field.on('keypress', function (e) {
        if ((e.which === 13) && this.value) {
          executeHeroSearch();
        }
      });

      $('.hero__search .search__input-group .form-submit', context).on('click', function (e) {
        if ($field.val()) {
          executeHeroSearch();
        }
      });
    }
  }
})(jQuery, Drupal);
